__turbopack_context__.v({
  "modal": "GE_69G_modal",
  "modal__content": "GE_69G_modal__content",
  "modal__content-wrapper": "GE_69G_modal__content-wrapper",
  "modal__footer": "GE_69G_modal__footer",
  "modal__header": "GE_69G_modal__header",
  "modal__icon": "GE_69G_modal__icon",
});
